<template>
  <div class="question">
    <template v-if="questionIndex && question[questionIndex]">
      <img class="img" v-for="(item, i) in question[questionIndex].imgs"
           :key="i" :src="checkQiNiuUrl(item)" alt="">
    </template>
    <div v-else
         style="text-align: center;line-height: 250px;color: #666;font-size: 14px;"
    >暂无该问题的解答哦</div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        questionIndex: '',
        question: {
          '1': {
            title: '如何在云柑5G云店开店?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题2-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题2-2.jpg',
            ]
          },
          '2': {
            title: '如何完成店铺实名认证?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题3-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题3-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题3-3.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题3-4.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题3-5.jpg',
            ]
          },
          '3': {
            title: '如何设置商品分类?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题4-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题4-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题4-3.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题4-4.jpg',
            ]
          },
          '4': {
            title: '如何发布店铺商品?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-3.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-4.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-5.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题5-6.jpg',
            ]
          },
          '5': {
            title: '如何编辑商品规格和详情?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题6-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题6-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题6-3.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题6-4.jpg',
            ]
          },
          '6': {
            title: '如何管理店铺商品?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题7.jpg',
            ]
          },
          '7': {
            title: '如何设置导航栏?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题8-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题8-2.jpg',
            ]
          },
          '8': {
            title: '如何设置商品运费?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题9-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题9-2.jpg',
            ]
          },
          '9': {
            title: '如何设置分享分销奖励?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题10.jpg',
            ]
          },
          '10': {
            title: '如何管理店铺订单?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题11.jpg',
            ]
          },
          '11': {
            title: '如何选择云店模板?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题12.jpg',
            ]
          },
          '12': {
            title: '如何进行资金提现?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题13-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题13-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题13-3.jpg',
            ]
          },
          '13': {
            title: '如何设置店铺主播?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题14.jpg',
            ]
          },
          '14': {
            title: '如何设置店铺广告?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题15.jpg',
            ]
          },
          '15': {
            title: '如何分销店铺商品?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题16.jpg',
            ]
          },
          '16': {
            title: '如何设置推广员?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题17.jpg',
            ]
          },
          '17': {
            title: '店铺会员如何设置?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题18.jpg',
            ]
          },
          '18': {
            title: '活动如何设置?',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题19-1.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题19-2.jpg',
              '5gShopApp/noviceGuideQuestion/202101071450/问题19-3.jpg',
            ]
          },
          '19': {
            title: '线下服务的设置',
            imgs: [
              '5gShopApp/noviceGuideQuestion/202101071450/问题20.jpg',
            ]
          },

        }
      }
    },
    created() {
      if(this.$route.query.question){
        this.questionIndex = this.$route.query.question
      }
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
.question{
  .img{
    display: block;
    width: 100%;
  }
}
</style>